import moment from 'moment'
const SATURDAY = 6
const SUNDAY = 0
const MIN_TIME_WEEK = 9
const MAX_TIME_WEEK = 21
const MIN_TIME_WEEKEND = 9
const MAX_TIME_WEEKEND = 17
export const isWeekend = (momentDay) => momentDay === SUNDAY || momentDay === SATURDAY

export const isOnTimeTable = (
    nowDate = moment(),
    minDate = moment(),
    maxDate = moment(),
) => {
    const momentDay = nowDate.day()
    if (isWeekend(momentDay)) {
        minDate.set('hour', MIN_TIME_WEEKEND)
        maxDate.set('hour', MAX_TIME_WEEKEND)
    } else {
        minDate.set('hour', MIN_TIME_WEEK)
        maxDate.set('hour', MAX_TIME_WEEK)
    }
    minDate.set('minute', 0)
    maxDate.set('minute', 0)
    return nowDate.isBetween(minDate, maxDate)
}
